export { type BioListProps, default as BioList } from './BioList';
